export const customPropertiesUpdate = (value: any) => {
    const root = document.documentElement;
    const keys = Object.keys(value);

    keys.forEach((key: string) => {
        if (key.indexOf('-') === 0) {
            root.style.setProperty(key, value[key]);
        }
    });
};

export const defaultCustomProperties = {
    '--avatar-border-color': '#DEDEDE',
    '--avatar-background-color': '#ECF0F4',
    '--avatar-border-width': '1px',
    '--avatar-border-style': 'solid',
    '--avatar-border-radius': '512px'
};

export const allCharactersArray = 'abcdefghijklmnopqrstuvwxyz_'
    .split('')
    .map(char => char.toLowerCase());
